import useOffers from 'hooks/Offers/useOffers'
import useOrder from 'hooks/Order/useOrder'
import { usePlaceByCoords } from 'hooks/usePlace'
import { getOrderItemsEligibleForCarHireBundledDiscount } from 'lib/carHire/carHireUtils'
import { useMemo } from 'react'

function useOrderItemsEligibleForCarHireBundledDiscount(orderId?: string) {
  const [order, isFetchingOrder] = useOrder(orderId)

  const offerIds = useMemo(() => {
    if (!order) return []
    return order.items.map((i) => i.offer.id)
  }, [order])

  const [offers, isFetchingOffers] = useOffers(offerIds)

  const itemsResult = useMemo(() => {
    if (!order) {
      return {
        earliestItem: undefined,
        latestItem: undefined,
        items: [],
      }
    }

    return getOrderItemsEligibleForCarHireBundledDiscount(order, offers)
  }, [order, offers])

  const [place, fetchingPlace] = usePlaceByCoords(itemsResult.earliestItem?.latitude, itemsResult.earliestItem?.longitude)

  return {
    ...itemsResult,
    place,
    fetching: isFetchingOrder || isFetchingOffers || fetchingPlace,
  }
}

export default useOrderItemsEligibleForCarHireBundledDiscount
